import { atom } from 'jotai';

const productsCountAtom = atom(null);

export default productsCountAtom;
